/**
 * Landing page — panel layout.
 *
 * Auth is enforced server-side (see src/server/index.ts): the SPA is never
 * served until the request passes the real auth gate, so this page can assume
 * the visitor is already authenticated and carries no login UI of its own.
 */

import { Link } from "react-router";
import labsLogo from "../assets/labs-logo.svg";
import ppImage from "../assets/pp.jpg";
import tobImage from "../assets/tob.jpg";

export function LandingPage() {
  return (
    <div className="landing-page">
      {/* Header */}
      <header className="landing-header container">
        <img src={labsLogo} alt="Iconic Labs" height={68} />
        <p className="header-tagline">
          Explore our collection of experimental<br />experiences &amp; games, playing with your voice.
        </p>
      </header>

      {/* Main content */}
      <main className="landing-main container">
        {/* Pressure Point */}
        <article className="panel panel--orange">
          <div className="panel__image">
            <img src={ppImage} alt="Pressure Point" />
          </div>
          <div className="panel__content">
            <div className="panel__top">
              <p className="panel__label">Experimental // 20 mins</p>
              <h2 className="panel__title">Pressure Point</h2>
            </div>
            <p className="panel__body">
              You are a marine biologist, the last sober passenger aboard the
              Prospero. You don&rsquo;t know how submarines work, but you have a
              lifeline: Lt. James Kovich, crackling through a radio. Can you
              work with him to save the passengers &ndash; or will you crack
              under the pressure?
            </p>
            <div className="panel__actions">
              <Link to="/play/pressurepoint" className="panel__cta">
                Play now in browser
              </Link>
              <a
                href="https://iconicgames.io/blog/pressure-point"
                className="panel__cta panel__cta--outline"
                target="_blank"
                rel="noopener noreferrer"
              >
                Learn more
              </a>
            </div>
          </div>
        </article>

        {/* The Oversight Bureau */}
        <article className="panel panel--blue">
          <div className="panel__image">
            <img src={tobImage} alt="The Oversight Bureau" />
          </div>
          <div className="panel__content">
            <div className="panel__top">
              <p className="panel__label">Game Demo // 30 mins</p>
              <h2 className="panel__title">The Oversight Bureau</h2>
            </div>
            <p className="panel__body">
              You are candidate 404, trapped inside C.U.T.E. - a rehabilitation
              program designed to make you a more &ldquo;appropriate&rdquo;
              member of society. As time ticks away and days blur, escape is the
              only way to keep your sanity and your voice, 404.
            </p>
            <a
              href="https://store.steampowered.com/app/4005360/The_Oversight_Bureau__Demo/"
              className="panel__cta"
              target="_blank"
              rel="noopener noreferrer"
            >
              Play now on Steam
            </a>
          </div>
        </article>
      </main>

      {/* Footer */}
      <footer className="landing-footer container">
        <span>Copyright Iconic Interactive 2026</span>
        <Link to="/privacy" className="landing-footer__link">Privacy Notice</Link>
      </footer>
    </div>
  );
}
